import type { DecompileResult } from "../workers/decompile/types.ts";
import type { ClassName } from "../utils/Names";

export type TokenType = 'class' | 'field' | 'method' | 'parameter' | 'local';

interface BaseToken {
    // The number of characters from the start of the source
    start: number;
    // The length of the token in characters
    length: number;
    // The name of the class this token represents
    className: ClassName;
    // Whether this token is a declaration or a reference
    declaration: boolean;
}

export interface MemberToken extends BaseToken {
    type: 'field' | 'method';
    // The member name
    name: string;
    // The member descriptor
    descriptor: string;
}

interface NonMethodToken extends BaseToken {
    type: 'class' | 'local';
}

export interface ParameterToken extends BaseToken {
    type: 'parameter';
    methodName: string;
    methodDescriptor: string;
    index: number;
    name: string;
}

export type Token = MemberToken | NonMethodToken | ParameterToken;

export interface TokenLocation {
    line: number,
    column: number;
    length: number;
}

export function getTokenLocation(result: DecompileResult, token: Token): TokenLocation {
    const sourceUpTo = result.source.slice(0, token.start);
    const line = (sourceUpTo.match(/\n/g)?.length ?? 0) + 1;
    const column = sourceUpTo.length - sourceUpTo.lastIndexOf("\n");
    return { line, column, length: token.length };
}
